module.exports = __webpack_public_path__ + "static/vetement2-f10efcba088fba68da47265693302ae3.jpg";